module.exports = __webpack_public_path__ + "static/media/loyalty-message-subtitle-icon.e25d4921.png";